export enum Difficulty {
  BEGINNER = 1,
  INTERMEDIATE,
  FLUENT,
  ADVANCED,
}
